import { Component } from '@angular/core';
import { DomSanitizer, Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { Dotcom2024Service } from '../../../dotcom2024.service';
import { environment } from '../../../../environments/environment';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MyharrellsService } from '../../../myharrells.service';
import { CanonicalService } from '../../../canonical.service';

@Component({
  selector: 'app-blog',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './blog.component.html',
  styleUrl: './blog.component.css'
})
export class BlogComponent {

  constructor(public myHarrellsService: MyharrellsService, private _sanitizer: DomSanitizer, public router: Router, public route: ActivatedRoute, private title: Title, private meta: Meta, public dotComService: Dotcom2024Service, private canonicalService: CanonicalService) { }


  pageImagePaths: string = environment.azureBlobStorageURL + environment.baseImagesFilePathBlobStorage + "/Resources/";
  blogImagePaths: string = environment.azureBlobStorageURL + environment.baseImagesFilePathBlobStorage + "/Blog-Photos/";
  baseImagePaths: string = environment.azureBlobStorageURL + environment.baseImagesFilePathBlobStorage + "/";
  imageExists: boolean = false;

  thisBlog: any = {};
  otherFeaturedPost1: any;
  otherFeaturedPost2: any;
  otherFeaturedPost3: any;
  validBlog: boolean = false;
  displayOops: boolean = false;


  ngOnInit(): void {

    this.title.setTitle("Harrell’s Blog | Agronomic Insights & Industry News");
    this.meta.updateTag({ name: 'description', content: "Stay informed with Harrell’s blog! Read research briefs, expert insights, customer stories, product updates, and listen to podcast episodes." });
    this.meta.updateTag({ property: 'og:title', content: "Harrell’s Blog | Agronomic Insights & Industry News" });
    this.meta.updateTag({ property: 'og:description', content: "Stay informed with Harrell’s blog! Read research briefs, expert insights, customer stories, product updates, and listen to podcast episodes." });
    // this.meta.updateTag({ property: 'og:image', content: "og:image here - blog" });
    // this.meta.updateTag({ property: 'og:url', content: "og:url here - blog" });
    this.meta.updateTag({ property: 'Twitter:card', content: "Harrell’s Blog | Agronomic Insights & Industry News" });
    this.meta.updateTag({ property: 'Twitter:site', content: "Harrell’s Blog | Agronomic Insights & Industry News" });
    this.meta.updateTag({ property: 'Twitter:title', content: "Harrell’s Blog | Agronomic Insights & Industry News" });
    this.meta.updateTag({ property: 'Twitter:description', content: "Stay informed with Harrell’s blog! Read research briefs, expert insights, customer stories, product updates, and listen to podcast episodes." });
    // this.meta.updateTag({ property: 'Twitter:image', content: "twitter:image here - blog" });
    this.meta.updateTag({ name: 'author', content: "Harrell's LLC" });
    // this.dotComService.createCanonicalURL();
    this.canonicalService.updateCanonicalURL(window.location.href);


    if (typeof window !== 'undefined') {
      const urlParams = new URLSearchParams(window.location.search);
      // Rest of the code that depends on the window object

      let blogAlias = urlParams.get('id');

      if (blogAlias == null) {
        //this could be a legacy link from the old site coming through 
        //that marketing used in the wild.  An example url in the old site was 
        //https://harrellstest.azurewebsites.net/Blog/Post/all-about-botrytis
        //try to get the blog name from that
        if (window.location.href.toLowerCase().indexOf('/blog/post/') > -1) {
          blogAlias = window.location.href.toLowerCase().substring(window.location.href.toLowerCase().indexOf('/blog/post/') + 11)
        }
      }


      //get the blogs details
      this.GetBlogDetails(blogAlias).then(result => {

      })
      this.GetRelatedResources(blogAlias);

    }

  }

  GetBlogDetails(blogAlias: string) {
    this.displayOops = false;
    return new Promise((resolve, reject) => {
      this.dotComService.GetBlog(blogAlias).subscribe((blog: any) => {
        this.thisBlog = blog;

        // let firstImage = blog.Content.substring(blog.Content.indexOf('<img'), blog.Content.indexOf('</p'))
        // let doc = new DOMParser().parseFromString(firstImage, 'text/html');
        // let firstImageStyle = (doc.body.children[0] as HTMLIFrameElement).style;
        // firstImageStyle.cssText = 'max-width:100%; ' + firstImageStyle.cssText

        //// const firstImage = document.querySelector('img');
        //// if (firstImage) {
        ////   firstImage.style.border = '2px solid red';
        ////   firstImage.style.borderRadius = '5px';
        ////   firstImage.style.maxWidth = '100% !important';
        //// } else {
        ////   console.log('No image tag found on the page.');
        //// }

        //makes the header image the same width as the blog content - THIS IS A FIX FOR THE CONTENT CREATED IN LEGACY APP
        blog.Content = blog.Content.replace("img ", "img style='max-width:100% !important' ")

        //dom sanitizer was stripping out color styles from the tinymce content
        //this trusts the html and allows the styles to be rendered
        this.thisBlog.Content = this._sanitizer.bypassSecurityTrustHtml(blog.Content);

        if (this.thisBlog.Id == 0) {
          //blog not found - it might have been marked as unpublished after it was marketed published 
          this.validBlog = false
          this.displayOops = true;
          resolve('');

        }
        else {
          this.validBlog = true
          let z = new Date(blog.PublishDate);
          this.thisBlog.PublishDate = z.toLocaleDateString("en-US");

          //check if the image exists
          //check to see if the image exists as a jpg, if not use png and then if neiter exist the html will show a default image
          this.dotComService.checkIfImageExists(this.blogImagePaths + blog.ItemAlias + ".jpg", (exists) => {
            if (exists) {
              // Success code
              this.thisBlog.ImageName = this.blogImagePaths + blog.ItemAlias + ".jpg"
            } else {
              // Fail code
              //this.dotComService.resourceFilteredPosts[i].ImageName = this.blogImagePaths + this.dotComService.resourceFilteredPosts[i].ItemAlias + ".png"
              this.dotComService.checkIfImageExists(this.blogImagePaths + blog.ItemAlias + ".png", (exists) => {
                if (exists) {
                  // Success code
                  this.thisBlog.ImageName = this.blogImagePaths + blog.ItemAlias + ".png"
                } else {
                  // Fail code - use default
                  this.thisBlog.ImageName = this.baseImagePaths + "harrellsh.png"
                }
              })
            }
            resolve('');
          });
        }

      })
    })
  }

  GetRelatedResources(blogAlias: string) {
    this.dotComService.GetRelatedBlogs(blogAlias).subscribe((blogs) => {

      if (blogs.length < 3 && this.validBlog) {
        alert("At least one featured blog is missing.  Please contact support for assistance.")
      }

      this.otherFeaturedPost1 = (blogs[0] != null) ? blogs[0] : [];
      this.otherFeaturedPost2 = (blogs[0] != null) ? blogs[1] : [];
      this.otherFeaturedPost3 = (blogs[0] != null) ? blogs[2] : [];

      //check for the correct image
      if (this.otherFeaturedPost1) {
        this.dotComService.checkIfImageExists(this.blogImagePaths + this.otherFeaturedPost1.ItemAlias + ".jpg", (exists) => {
          if (exists) {
            // Success code
            this.otherFeaturedPost1.ImageName = this.blogImagePaths + this.otherFeaturedPost1.ItemAlias + ".jpg"
          } else {
            // Fail code
            this.dotComService.checkIfImageExists(this.blogImagePaths + this.otherFeaturedPost1.ItemAlias + ".png", (exists) => {
              if (exists) {
                // Success code
                this.otherFeaturedPost1.ImageName = this.blogImagePaths + this.otherFeaturedPost1.ItemAlias + ".png"
              } else {
                // Fail code - use default
                this.otherFeaturedPost1.ImageName = this.baseImagePaths + "harrellsh.png"
              }
            })
          }
        });
      }

      //check for the correct image
      if (this.otherFeaturedPost2) {
        this.dotComService.checkIfImageExists(this.blogImagePaths + this.otherFeaturedPost2.ItemAlias + ".jpg", (exists) => {
          if (exists) {
            // Success code
            this.otherFeaturedPost2.ImageName = this.blogImagePaths + this.otherFeaturedPost2.ItemAlias + ".jpg"
          } else {
            // Fail code
            this.dotComService.checkIfImageExists(this.blogImagePaths + this.otherFeaturedPost2.ItemAlias + ".png", (exists) => {
              if (exists) {
                // Success code
                this.otherFeaturedPost2.ImageName = this.blogImagePaths + this.otherFeaturedPost2.ItemAlias + ".png"
              } else {
                // Fail code - use default
                this.otherFeaturedPost2.ImageName = this.baseImagePaths + "harrellsh.png"
              }
            })
          }
        });
      }

      //check for the correct image
      if (this.otherFeaturedPost3) {
        this.dotComService.checkIfImageExists(this.blogImagePaths + this.otherFeaturedPost3.ItemAlias + ".jpg", (exists) => {
          if (exists) {
            // Success code
            this.otherFeaturedPost3.ImageName = this.blogImagePaths + this.otherFeaturedPost3.ItemAlias + ".jpg"
          } else {
            // Fail code
            this.dotComService.checkIfImageExists(this.blogImagePaths + this.otherFeaturedPost3.ItemAlias + ".png", (exists) => {
              if (exists) {
                // Success code
                this.otherFeaturedPost3.ImageName = this.blogImagePaths + this.otherFeaturedPost3.ItemAlias + ".png"
              } else {
                // Fail code - use default
                this.otherFeaturedPost3.ImageName = this.baseImagePaths + "harrellsh.png"
              }
            })
          }
        });
      }
    })
  }

  GoToBlog(blog) {

    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigateByUrl('/blog?id=' + blog.ItemAlias);
    });

  }

}
